(() => {
    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, window.cartStrings?.money_format);
      }
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    };

    const initStudio = (root) => {
      if (!root || root.dataset.initialized === 'true' || root.dataset.initializing === 'true') return;
      root.dataset.initializing = 'true';

      const form = root.querySelector('.b2h-v3-product-studio__form');
      if (!form) {
        delete root.dataset.initializing;
        return;
      }

      let managedArtworkRecords = [];
      const managedLibraryNode = root.querySelector('[data-managed-artwork-library]');
      if (managedLibraryNode) {
        try {
          managedArtworkRecords = JSON.parse(managedLibraryNode.textContent || '[]');
          const visualKindByRecordKind = {
            dog: 'dog-breed',
            cat: 'cat-pattern',
            background: 'background'
          };
          const normalizeVisualValue = (value) =>
            String(value ?? '')
              .replace(/\s+/g, ' ')
              .trim()
              .toLowerCase();
          const createImageOptionButton = (record, visualKind, optionValue) => {
            const sourceCode = String(record.sourceCode || record.assetCode || '');
            const displayName = String(record.uiDisplayName || record.displayName || record.label || optionValue || '');
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'b2h-control b2h-item b2h-v3-product-studio__visual-option';
            button.dataset.visualOption = visualKind;
            button.dataset.optionValue = optionValue;
            button.dataset.optionImage = record.imageUrl || '';
            button.dataset.optionAsset = record.key || '';
            button.dataset.optionSourceCode = sourceCode;
            button.dataset.optionLayout = JSON.stringify(record.layout || {});
            button.setAttribute('aria-pressed', 'false');

            const media = document.createElement('span');
            media.className = 'b2h-v3-product-studio__visual-option-media';
            const image = document.createElement('img');
            image.src = record.thumbnailUrl || record.imageUrl || '';
            image.alt = '';
            image.width = 160;
            image.height = 160;
            image.loading = 'lazy';
            media.append(image);

            const label = document.createElement('span');
            if (visualKind === 'cat-pattern' && sourceCode) {
              const labelStrong = document.createElement('strong');
              labelStrong.textContent = sourceCode;
              label.append(labelStrong);
              if (displayName) label.append(` ${displayName}`);
            } else {
              label.textContent = visualKind === 'background' && sourceCode ? `${sourceCode} - ${displayName}` : displayName;
            }

            const check = document.createElement('span');
            check.className = 'b2h-v3-product-studio__visual-option-check';
            check.setAttribute('aria-hidden', 'true');
            check.textContent = '✓';

            button.append(media, label, check);
            return button;
          };
          const quickGrids = {
            dog: root.querySelector('.b2h-v3-product-studio__visual-grid--quick[data-visual-options="dog-breed"]'),
            cat: root.querySelector('.b2h-v3-product-studio__visual-grid--quick[data-visual-options="cat-pattern"]'),
            background: root.querySelector('.b2h-v3-product-studio__visual-grid--quick[data-visual-options="background"]')
          };
          const libraryGrids = {
            dog: root.querySelector('[data-visual-library="dog-breed"] .b2h-v3-product-studio__visual-grid--library[data-visual-options="dog-breed"]'),
            cat: root.querySelector('[data-visual-library="cat-pattern"] .b2h-v3-product-studio__visual-grid--library[data-visual-options="cat-pattern"]'),
            background: root.querySelector('[data-visual-library="background"] .b2h-v3-product-studio__visual-grid--library[data-visual-options="background"]')
          };
          const quickSeedValues = {
            dog: new Set(Array.from(quickGrids.dog?.querySelectorAll('[data-visual-option]') || []).map((button) => normalizeVisualValue(button.dataset.optionValue))),
            cat: new Set(Array.from(quickGrids.cat?.querySelectorAll('[data-visual-option]') || []).map((button) => normalizeVisualValue(button.dataset.optionValue))),
            background: new Set(Array.from(quickGrids.background?.querySelectorAll('[data-visual-option]') || []).map((button) => normalizeVisualValue(button.dataset.optionValue)))
          };
          const targets = {
            dog: {
              select: form.querySelector('[data-visual-select="dog-breed"]'),
              quick: quickGrids.dog,
              library: libraryGrids.dog
            },
            cat: {
              select: form.querySelector('[data-visual-select="cat-pattern"]'),
              quick: quickGrids.cat,
              library: libraryGrids.cat
            },
            background: {
              select: form.querySelector('[data-visual-select="background"]'),
              quick: quickGrids.background,
              library: libraryGrids.background
            }
          };
          Object.values(targets).forEach((target) => {
            target.select?.querySelectorAll('option[data-option-asset]').forEach((option) => option.remove());
            target.quick?.querySelectorAll('[data-visual-option]').forEach((button) => button.remove());
            target.library?.querySelectorAll('[data-visual-option]').forEach((button) => button.remove());
          });
          const dedupeGridByValue = (grid) => {
            const seen = new Set();
            grid?.querySelectorAll('[data-visual-option]').forEach((button) => {
              const optionValue = normalizeVisualValue(button.dataset.optionValue);
              if (!optionValue) return;
              if (seen.has(optionValue)) button.remove();
              else seen.add(optionValue);
            });
          };
          const seenRecordKeys = new Set();
          const seenSelectValues = {
            dog: new Set(),
            cat: new Set(),
            background: new Set()
          };
          managedArtworkRecords.forEach((record) => {
            const target = targets[record.kind];
            if (!target?.select || !record?.kind) return;
            const sourceCode = record.sourceCode || '';
            const displayName = record.displayName || '';
            const optionValue = record.kind === 'background' || record.kind === 'cat'
              ? `${sourceCode} - ${displayName}`
              : displayName;
            const visualKind = visualKindByRecordKind[record.kind];
            const stableRecordKey = normalizeVisualValue(`${record.kind}|${record.key || ''}`);
            if (seenRecordKeys.has(stableRecordKey)) return;
            seenRecordKeys.add(stableRecordKey);
            const normalizedOptionValue = normalizeVisualValue(optionValue);
            if (seenSelectValues[record.kind].has(normalizedOptionValue)) return;
            seenSelectValues[record.kind].add(normalizedOptionValue);
            const recordImage = record.imageUrl || '';
            const recordLayout = record.layout || {};
            const option = document.createElement('option');
            option.value = optionValue;
            option.textContent = record.kind === 'background' || record.kind === 'cat'
              ? `${sourceCode} - ${record.uiDisplayName || displayName}` : (record.uiDisplayName || displayName);
            option.dataset.optionImage = recordImage;
            option.dataset.optionAsset = record.key;
            option.dataset.optionSourceCode = sourceCode || record.assetCode || '';
            option.dataset.optionLayout = JSON.stringify(recordLayout);
            target.select.append(option);
            const optionSeed = quickSeedValues[record.kind] || new Set();
            const showInQuick = target.quick
              ? optionSeed.has(normalizedOptionValue) || optionSeed.size === 0
              : false;
            const visualButton = createImageOptionButton({ ...record, sourceCode }, visualKind, optionValue);
            if (showInQuick) {
              target.quick.append(visualButton.cloneNode(true));
            }
            const showInLibrary = record.kind === 'dog' || !showInQuick;
            if (target.library && showInLibrary) {
              target.library.append(visualButton.cloneNode(true));
            }
          });
          ['dog-breed', 'cat-pattern', 'background'].forEach((kind) => {
            root.querySelectorAll(`[data-visual-options="${kind}"]`).forEach((grid) => dedupeGridByValue(grid));
          });
        } catch (error) {
          console.warn('B2H managed artwork JSON unavailable', error);
        }
      }

      const populateGenericArtwork = (artworkKind) => {
        const field = form.querySelector('[data-generic-pet-artwork-field]');
        const select = field?.querySelector('[data-visual-select="pet-artwork"]');
        const quick = field?.querySelector('.b2h-v3-product-studio__visual-grid--quick[data-visual-options="pet-artwork"]');
        const library = field?.querySelector('.b2h-v3-product-studio__visual-grid--library[data-visual-options="pet-artwork"]');
        if (!field || !select || !quick || !library || field.dataset.loadedArtworkKind === artworkKind) return;

        select.querySelectorAll('option[data-option-asset]').forEach((option) => option.remove());
        quick.replaceChildren();
        library.replaceChildren();
        select.value = '';
        const seen = new Set();
        const records = managedArtworkRecords.filter((record) => record?.kind === artworkKind);
        records.forEach((record, index) => {
          const sourceCode = String(record.sourceCode || record.assetCode || '').trim();
          const displayName = String(record.displayName || record.label || record.key || '').trim();
          const optionValue = sourceCode ? `${sourceCode} - ${displayName}` : displayName;
          const dedupeKey = optionValue.replace(/\s+/g, ' ').trim().toLocaleLowerCase();
          if (!dedupeKey || seen.has(dedupeKey)) return;
          seen.add(dedupeKey);

          const option = document.createElement('option');
          option.value = optionValue;
          option.textContent = sourceCode ? `${sourceCode} - ${record.uiDisplayName || displayName}` : (record.uiDisplayName || displayName);
          option.dataset.optionImage = record.imageUrl || '';
          option.dataset.optionAsset = record.key || '';
          option.dataset.optionSourceCode = sourceCode;
          option.dataset.optionLayout = JSON.stringify(record.layout || {});
          select.append(option);

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'b2h-control b2h-item b2h-v3-product-studio__visual-option';
          button.dataset.visualOption = 'pet-artwork';
          button.dataset.optionValue = optionValue;
          button.dataset.optionImage = record.imageUrl || '';
          button.dataset.optionAsset = record.key || '';
          button.dataset.optionSourceCode = sourceCode;
          button.dataset.optionLayout = JSON.stringify(record.layout || {});
          button.setAttribute('aria-pressed', 'false');

          const media = document.createElement('span');
          media.className = 'b2h-v3-product-studio__visual-option-media';
          const image = document.createElement('img');
          image.src = record.thumbnailUrl || record.imageUrl || '';
          image.alt = '';
          image.width = 160;
          image.height = 160;
          image.loading = 'lazy';
          media.append(image);
          const label = document.createElement('span');
          label.textContent = sourceCode ? `${sourceCode} - ${record.uiDisplayName || displayName}` : (record.uiDisplayName || displayName);
          const check = document.createElement('span');
          check.className = 'b2h-v3-product-studio__visual-option-check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          button.append(media, label, check);
          library.append(button);
          if (index < 6) quick.append(button.cloneNode(true));
        });
        field.dataset.loadedArtworkKind = artworkKind;
        field.querySelector('[data-visual-empty="pet-artwork"]')?.toggleAttribute('hidden', records.length > 0);
      };

      const variantsNode = form.querySelector('[data-product-variants]');
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const variantInput = form.querySelector('[data-variant-id]');
      const submit = form.querySelector('[data-submit-button]');
      const submitLabel = form.querySelector('[data-submit-label]');
      const submitPrice = form.querySelector('[data-submit-price]');
      const price = root.querySelector('[data-product-price]');
      const compare = root.querySelector('[data-compare-price]');
      const optionalLabel = root.dataset.reviewOptionalLabel || 'Optional';
      const requiredLabel = root.dataset.reviewRequiredLabel || 'Required';
      const soldOutLabel = submit?.dataset.soldOutLabel || 'Sold out';
      const availableLabel = submit?.dataset.availableLabel || 'Add to cart';
      const owner = root.closest('.shopify-section') || root.parentElement;
      const gallery = root.querySelector('media-gallery[data-shared-media]');
      const groupedPetMedia = root.dataset.petMediaGroups === 'true';
      const selectedPetTypeControl = () => form.querySelector('[data-pet-type]:checked');
      const selectedPetTypeKey = () => {
        const control = selectedPetTypeControl();
        return String(control?.dataset.petTypeKey || control?.value || 'dog').trim().toLocaleLowerCase();
      };
      const selectedArtworkKind = () => {
        const control = selectedPetTypeControl();
        return String(control?.dataset.artworkKind || control?.dataset.petTypeKey || control?.value || 'dog').trim().toLocaleLowerCase();
      };
      const selectedArtworkVisualKey = () => {
        const artworkKind = selectedArtworkKind();
        if (artworkKind === 'dog') return 'dog-breed';
        if (artworkKind === 'cat') return 'cat-pattern';
        return 'pet-artwork';
      };
      const livePreview = root.querySelector('[data-live-preview]');
      const sizePopup = owner?.querySelector('[data-size-popup]');
      const productComparePopup = owner?.querySelector('[data-product-compare-popup]');
      let hasAutoOpenedPreview = root.dataset.previewAutoOpened === 'true';
      let photoObjectUrl = null;
      let pendingPhotoUrl = null;
      let photoValidationToken = 0;
      let syncPortablePreview = () => {};
      const scheduleStickyUpdate = () => gallery?.scheduleSticky();
      const syncMediaGroup = petType => { if (groupedPetMedia) gallery?.setGroup(petType); };
      const setViewMode = mode => gallery?.setPreview(mode === 'preview');

      root.querySelector('[data-photo-proof-jump]')?.addEventListener('click', event => {
        const proofThumb = gallery?.querySelector('[data-gallery-thumb][data-media-proof="actual-finished"]');
        if (!gallery?.swiper || !proofThumb || proofThumb.hidden) return;
        event.preventDefault();
        proofThumb.click();
        requestAnimationFrame(() => {
          const viewport = gallery.querySelector('[data-gallery-viewport]');
          if (!viewport) return;
          viewport.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          viewport.focus({ preventScroll: true });
        });
      });

      const openPreviewForMeaningfulInput = (field) => {
        if (hasAutoOpenedPreview || !livePreview || !field) return;
        const suncatcherPreviewRevealSources = new Set(['dog-breed', 'cat-pattern', 'pet-artwork', 'background']);
        const canRevealPreview = root.dataset.suncatcherPersonalization !== 'true'
          || field.matches('[data-photo-upload]')
          || suncatcherPreviewRevealSources.has(field.dataset.reviewSource);
        if (!canRevealPreview) return;
        const meaningful = field.type === 'checkbox'
          ? field.checked
          : field.type === 'file'
            ? Boolean(field.files?.length)
            : String(field.value || '').trim().length > 0;
        if (!meaningful) return;
        hasAutoOpenedPreview = true;
        setViewMode('preview');
      };

      root.querySelector('[data-compare-dialog-open]')?.addEventListener('click', async (event) => {
        const trigger = event.currentTarget;
        await customElements.whenDefined('b2h-template-popup');
        const mode = trigger.dataset.compareMode;
        if (mode === 'products') {
          productComparePopup?.openFromTemplate?.(trigger);
          return;
        }
        if (mode === 'sizes' && sizePopup?.openFromTemplate) {
          sizePopup.openFromTemplate(trigger, (modalBox) => {
            const sizeButtons = Array.from(modalBox.querySelectorAll('[data-size-value]'));
            const selectedValues = selectedOptions();
            sizeButtons.forEach((button) => {
              button.classList.toggle('is-selected', selectedValues.includes(button.dataset.sizeValue));
              button.addEventListener('click', () => {
                const input = Array.from(form.querySelectorAll('[data-product-options] input')).find((item) => item.value === button.dataset.sizeValue);
                if (!input) return;
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
                sizeButtons.forEach((item) => item.classList.toggle('is-selected', item === button));
                sizePopup.closePopup();
              });
            });
          });
        }
      });

      const updateReview = (key, value, fallback) => {
        const target = form.querySelector(`[data-review-value="${key}"]`);
        if (!target) return;
        const selector = key === 'photo-file' ? '[data-photo-upload]' : `[data-review-source="${key}"]`;
        const required = Array.from(form.querySelectorAll(selector)).some(field => field.required && !field.matches(':disabled'));
        let displayValue = value;
        const selectedControl = form.querySelector(`${selector}:checked`) || form.querySelector(selector);
        if (value && value === selectedControl?.value && selectedControl instanceof HTMLSelectElement) {
          displayValue = selectedControl.selectedOptions[0]?.textContent?.trim() || value;
        } else if (value && value === selectedControl?.value && selectedControl instanceof HTMLInputElement && selectedControl.type === 'radio') {
          displayValue = selectedControl.dataset.reviewLabel || selectedControl.labels?.[0]?.textContent?.trim() || value;
        }
        target.textContent = String(displayValue || '').trim() || fallback || (required ? requiredLabel : optionalLabel);
      };

      const displayVariantTitle = (variant) => {
        const isLegacySuncatcherSize = root.dataset.suncatcherPersonalization === 'true'
          && variant?.options?.includes('3.54 inch');
        const isCanonicalSmallSize = root.dataset.legacySizeRetired === 'true'
          && variant?.options?.includes('4 inch');
        if (isLegacySuncatcherSize) return root.dataset.legacySizeLabel;
        if (isCanonicalSmallSize) return root.dataset.canonicalSmallSizeLabel;
        const option = Array.from(form.querySelectorAll('[data-pdp-native-variant] option')).find(item => item.value === String(variant?.id));
        return option?.dataset.uiTitle || variant?.title;
      };

      const selectedOptions = () => Array.from(form.querySelectorAll('[data-product-options] input:checked')).map((input) => input.value);

      const syncMoonMessage = () => {
        const field = form.querySelector('[data-moon-message-field]');
        const input = field?.querySelector('input');
        const review = form.querySelector('[data-moon-message-review]');
        const liveMoonMessage = root.querySelector('[data-live-moon-message]');
        const liveMoonMessageText = root.querySelector('[data-live-moon-message-text]');
        if (!field || !input || !review) return;
        const selectedSize = selectedOptions().find((value) => /inch/i.test(value)) || '';
        const petTypeControl = selectedPetTypeControl();
        const messageLimit = Number.parseInt(petTypeControl?.dataset.moonMessageMaxlength || '60', 10) || 60;
        const supportsMessage = petTypeControl?.dataset.supportsMoonMessage === 'true' && /^(5|6)(?:\s|$)/.test(selectedSize);
        const limitError = field.querySelector('[data-moon-message-limit-error]');
        const tooLong = supportsMessage && input.value.length > messageLimit;
        const errorText = tooLong ? (limitError?.dataset.template || '').replace('__LIMIT__', String(messageLimit)) : '';
        input.maxLength = messageLimit;
        input.setCustomValidity(errorText);
        field.hidden = !supportsMessage;
        input.disabled = !supportsMessage;
        review.hidden = !supportsMessage;
        if (limitError) {
          limitError.textContent = errorText;
          limitError.hidden = !tooLong;
        }
        updateReview('moon-message', supportsMessage && !tooLong ? input.value : '');
        if (liveMoonMessageText) liveMoonMessageText.textContent = supportsMessage && !tooLong ? input.value.trim() : '';
        liveMoonMessage?.toggleAttribute('hidden', !supportsMessage || tooLong || !input.value.trim());
        syncPortablePreview();
      };

      const updateVariant = () => {
        if (!variants.length) return;
        const options = selectedOptions();
        const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
        if (!variant) {
          if (submit) submit.disabled = true;
          return;
        }

        variantInput.value = variant.id;
        if (price) price.textContent = formatMoney(variant.price);
        if (compare) {
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          compare.classList.toggle('is-hidden', !onSale);
          compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        }
        if (submit) submit.disabled = !variant.available;
        if (submitLabel) submitLabel.textContent = variant.available ? availableLabel : soldOutLabel;
        if (submitPrice) submitPrice.textContent = variant.available ? formatMoney(variant.price) : '';
        updateReview('variant', displayVariantTitle(variant), requiredLabel);
        syncMoonMessage();

        if (variant.featured_media?.id) {
          gallery?.goToMediaId(variant.featured_media.id);
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        root.dispatchEvent(new CustomEvent('b2h:variant-change', {
          bubbles: true,
          detail: { variant }
        }));
      };

      form.querySelectorAll('[data-product-options] input').forEach((input) => input.addEventListener('change', updateVariant));

      const quantity = form.querySelector('input[name="quantity"]');
      form.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.quantityChange));
          quantity.value = next;
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      const liveName = root.querySelector('[data-live-name]');
      const liveDates = root.querySelector('[data-live-dates]');
      const livePhoto = root.querySelector('[data-live-photo]');
      const liveArtwork = root.querySelector('[data-live-artwork]');
      const liveMoon = root.querySelector('[data-live-moon]');
      const liveSymbol = root.querySelector('[data-live-symbol]');
      const livePiece = root.querySelector('[data-live-piece]');
      const petNameField = form.querySelector('[data-review-source="pet-name"]');
      const datesField = form.querySelector('[data-review-source="dates"]');
      const liveNameFallback = liveName?.textContent || 'Pet name';
      const liveDatesFallback = liveDates?.textContent || 'Memorial dates';
      const usesSuncatcherPhoto = () => form.querySelector('[data-suncatcher-artwork-mode]:checked')?.value === 'Custom photo portrait';

      const fitLiveText = () => {
        requestAnimationFrame(() => {
          [
            { element: liveName, minimum: 7 },
            { element: liveDates, minimum: 5.5 }
          ].forEach(({ element, minimum }) => {
            if (!element) return;
            element.style.removeProperty('font-size');
            let size = Number.parseFloat(getComputedStyle(element).fontSize);
            if (!Number.isFinite(size)) size = minimum;
            const dynamicMinimum = Math.max(4, size * 0.55);
            while (element.scrollWidth > element.clientWidth + 1 && size > dynamicMinimum) {
              size = Math.max(dynamicMinimum, size - 0.25);
              element.style.fontSize = `${size}px`;
            }
          });
        });
      };

      const syncLiveText = () => {
        if (liveName) liveName.textContent = petNameField?.value.trim() || liveNameFallback;
        if (liveDates) liveDates.textContent = datesField?.value.trim() || liveDatesFallback;
        fitLiveText();
        syncPortablePreview();
      };

      const reviewSourceValue = (field) => {
        if (field.type !== 'radio') return field.value;
        const key = field.dataset.reviewSource;
        return form.querySelector(`[data-review-source="${key}"]:checked`)?.value || '';
      };

      form.querySelectorAll('[data-review-source]').forEach((field) => {
        const sync = () => {
          updateReview(field.dataset.reviewSource, reviewSourceValue(field));
          syncLiveText();
          openPreviewForMeaningfulInput(field);
        };
        field.addEventListener('input', sync);
        field.addEventListener('change', sync);
        updateReview(field.dataset.reviewSource, reviewSourceValue(field));
      });

      const selectedVisualOption = (key) => {
        const select = form.querySelector(`[data-visual-select="${key}"]`);
        return select?.selectedOptions?.[0] || null;
      };

      const mobilePreviewDock = form.querySelector('[data-mobile-preview-dock]');
      const mobilePreview = form.querySelector('[data-mobile-personalization-preview]');
      const mobilePreviewSummary = form.querySelector('[data-mobile-preview-summary]');
      const mobilePreviewToggle = form.querySelector('[data-mobile-preview-toggle]');
      // This component clears the actual fixed header, independently of the
      // theme wrapper's legacy sticky/hidden class names. Measure at layout
      // changes only; never run header geometry reads on scrolling frames.
      if (mobilePreviewDock) {
        const previewHeader = document.querySelector('header.b2h-native-header') || document.querySelector('.section-header');
        let clearanceFrame = 0;
        const updatePreviewClearance = () => {
          clearanceFrame = 0;
          if (!root.isConnected) return;
          const headerBounds = previewHeader?.getBoundingClientRect();
          const headerStyle = previewHeader ? getComputedStyle(previewHeader) : null;
          const headerBottom = headerBounds && headerBounds.height > 0 && headerStyle.visibility !== 'hidden' && headerStyle.display !== 'none'
            ? Math.max(0, headerBounds.bottom) : 0;
          const gap = parseFloat(getComputedStyle(form).getPropertyValue('--b2h-space-xs')) * parseFloat(getComputedStyle(document.documentElement).fontSize) || 8;
          const top = Math.ceil(headerBottom + gap);
          form.style.setProperty('--b2h-preview-top', `${top}px`);
          form.style.setProperty('--b2h-preview-field-clearance', `${Math.ceil(top + mobilePreviewDock.getBoundingClientRect().height + gap)}px`);
        };
        const schedulePreviewClearance = () => {
          if (!clearanceFrame) clearanceFrame = requestAnimationFrame(updatePreviewClearance);
        };
        const previewResize = new ResizeObserver(schedulePreviewClearance);
        if (previewHeader) previewResize.observe(previewHeader);
        previewResize.observe(mobilePreviewDock);
        const clearanceEvents = new AbortController();
        window.addEventListener('resize', schedulePreviewClearance, { passive: true, signal: clearanceEvents.signal });
        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(root)) return;
          previewResize.disconnect();
          clearanceEvents.abort();
          if (clearanceFrame) cancelAnimationFrame(clearanceFrame);
        }, { signal: clearanceEvents.signal });
        schedulePreviewClearance();
      }

      const previewSurfaceUrl = form.querySelector('[data-preview-surface-url]');
      const previewArtworkAsset = form.querySelector('[data-preview-artwork-asset]');
      const previewArtworkUrl = form.querySelector('[data-preview-artwork-url]');
      const previewArtworkKind = form.querySelector('[data-preview-artwork-kind]');
      const previewBackgroundAsset = form.querySelector('[data-preview-background-asset]');
      const previewBackgroundUrl = form.querySelector('[data-preview-background-url]');
      const previewLayoutInput = form.querySelector('[data-preview-layout]');
      let fallbackPreviewLayout = {};
      try {
        fallbackPreviewLayout = JSON.parse(previewLayoutInput?.value || '{}');
      } catch (error) {
        fallbackPreviewLayout = {};
      }
      let portablePreviewLayout = fallbackPreviewLayout;

      const clampPreviewValue = (value, minimum, maximum) =>
        Math.min(maximum, Math.max(minimum, Number(value)));
      const roundPreviewValue = (value) => Math.round(value * 100) / 100;
      const adjustedTextLayout = (layout) => {
        if (!Array.isArray(layout) || layout.length < 4) return layout;
        const offsetX = Number(root.dataset.previewTextOffsetX || 0);
        const offsetY = Number(root.dataset.previewTextOffsetY || 0);
        const widthScale = Number(root.dataset.previewTextWidthScale || 100) / 100;
        const sizeScale = Number(root.dataset.previewTextSizeScale || 100) / 100;
        return [
          roundPreviewValue(clampPreviewValue(Number(layout[0]) + offsetX, 0, 100)),
          roundPreviewValue(clampPreviewValue(Number(layout[1]) + offsetY, 0, 100)),
          roundPreviewValue(clampPreviewValue(Number(layout[2]) * widthScale, 4, 100)),
          roundPreviewValue(clampPreviewValue(Number(layout[3]) * sizeScale, 0.5, 12))
        ];
      };

      const syncPreviewLayout = () => {
        const artworkKey = selectedArtworkVisualKey();
        const artworkOption = selectedVisualOption(artworkKey);
        const useArtworkLayout = root.dataset.previewAutoArtworkLayout === 'true' && !usesSuncatcherPhoto();
        let artworkTextLayout = {};
        if (useArtworkLayout && artworkOption?.dataset.optionLayout) {
          try {
            artworkTextLayout = JSON.parse(artworkOption.dataset.optionLayout);
          } catch (error) {
            artworkTextLayout = {};
          }
        }

        const hasArtworkLayout = Array.isArray(artworkTextLayout.name) && Array.isArray(artworkTextLayout.dates);
        portablePreviewLayout = {
          ...fallbackPreviewLayout,
          name: hasArtworkLayout ? adjustedTextLayout(artworkTextLayout.name) : fallbackPreviewLayout.name,
          dates: hasArtworkLayout ? adjustedTextLayout(artworkTextLayout.dates) : fallbackPreviewLayout.dates
        };

        const nameLayout = portablePreviewLayout.name;
        const datesLayout = portablePreviewLayout.dates;
        if (Array.isArray(nameLayout)) {
          root.style.setProperty('--b2h-v3-preview-name-x', `${nameLayout[0]}%`);
          root.style.setProperty('--b2h-v3-preview-name-y', `${nameLayout[1]}%`);
          root.style.setProperty('--b2h-v3-preview-name-width', `${nameLayout[2]}%`);
          root.style.setProperty('--b2h-v3-preview-name-size', String(nameLayout[3]));
        }
        if (Array.isArray(datesLayout)) {
          root.style.setProperty('--b2h-v3-preview-dates-x', `${datesLayout[0]}%`);
          root.style.setProperty('--b2h-v3-preview-dates-y', `${datesLayout[1]}%`);
          root.style.setProperty('--b2h-v3-preview-dates-width', `${datesLayout[2]}%`);
          root.style.setProperty('--b2h-v3-preview-dates-size', String(datesLayout[3]));
        }
        if (previewLayoutInput) previewLayoutInput.value = JSON.stringify(portablePreviewLayout);
        fitLiveText();
      };

      if ('ResizeObserver' in window && livePiece) {
        const livePreviewObserver = new ResizeObserver(fitLiveText);
        livePreviewObserver.observe(livePiece);
      }

      syncPortablePreview = () => {
        if (!mobilePreview) return;
        const artworkKey = selectedArtworkVisualKey();
        const artworkOption = selectedVisualOption(artworkKey);
        const backgroundOption = selectedVisualOption('background');
        const usePhoto = usesSuncatcherPhoto();
        const artworkSrc = usePhoto ? '' : artworkOption?.dataset.optionImage || '';
        const artworkAsset = usePhoto ? '' : artworkOption?.dataset.optionAsset || '';
        const backgroundSrc = backgroundOption?.dataset.optionImage || '';
        const backgroundAsset = backgroundOption?.dataset.optionAsset || '';
        const photoCropInput = form.querySelector('select[data-photo-crop]');
        const photoZoomInput = form.querySelector('[data-photo-control="zoom"]');
        const photoXInput = form.querySelector('[data-photo-control="x"]');
        const photoYInput = form.querySelector('[data-photo-control="y"]');
        const moonMessageInput = form.querySelector('[data-moon-message-field] input:not(:disabled)');
        const recipe = {
          recipeKey: root.dataset.photoPortraitOnly === 'true' ? 'photo-suncatcher-v1' : 'suncatcher-v1',
          surfaceSrc: previewSurfaceUrl?.value || '',
          backgroundSrc,
          artworkSrc,
          photoSrc: usePhoto ? photoObjectUrl || '' : '',
          photoCrop: photoCropInput?.value || 'Face focus',
          photoZoom: Number(photoZoomInput?.value || 100),
          photoX: Number(photoXInput?.value || 50),
          photoY: Number(photoYInput?.value || 50),
          petName: petNameField?.value.trim() || '',
          dates: datesField?.value.trim() || '',
          moonMessage: moonMessageInput?.value.trim() || '',
          layout: portablePreviewLayout
        };

        if (previewArtworkAsset) previewArtworkAsset.value = artworkAsset;
        if (previewArtworkUrl) previewArtworkUrl.value = artworkSrc;
        if (previewArtworkKind) previewArtworkKind.value = selectedArtworkKind();
        if (previewBackgroundAsset) previewBackgroundAsset.value = backgroundAsset;
        if (previewBackgroundUrl) previewBackgroundUrl.value = backgroundSrc;

        mobilePreview.dataset.recipe = recipe.recipeKey;
        mobilePreview.dataset.surfaceSrc = recipe.surfaceSrc;
        mobilePreview.dataset.backgroundSrc = recipe.backgroundSrc;
        mobilePreview.dataset.artworkSrc = recipe.artworkSrc;
        mobilePreview.dataset.photoSrc = recipe.photoSrc;
        mobilePreview.dataset.photoCrop = recipe.photoCrop;
        mobilePreview.dataset.photoZoom = String(recipe.photoZoom);
        mobilePreview.dataset.photoX = String(recipe.photoX);
        mobilePreview.dataset.photoY = String(recipe.photoY);
        mobilePreview.dataset.petName = recipe.petName;
        mobilePreview.dataset.dates = recipe.dates;
        mobilePreview.dataset.moonMessage = recipe.moonMessage;
        mobilePreview.dataset.layout = JSON.stringify(recipe.layout);

        if (customElements.get('b2h-personalization-preview')) {
          mobilePreview.recipe = recipe;
        } else {
          customElements.whenDefined('b2h-personalization-preview').then(() => {
            if (mobilePreview.isConnected) mobilePreview.recipe = recipe;
          });
        }

        const meaningful = Boolean(artworkSrc || recipe.photoSrc || backgroundSrc || recipe.petName || recipe.dates);
        if (mobilePreviewDock) mobilePreviewDock.hidden = !meaningful;
        if (mobilePreviewSummary) {
          const summaryParts = [
            artworkOption?.value,
            backgroundOption?.value,
            recipe.petName
          ].filter(Boolean);
          mobilePreviewSummary.textContent = summaryParts.join(' · ') || mobilePreviewSummary.dataset.emptySummary;
        }
      };

      const setMobilePreviewExpanded = (expanded) => {
        if (!mobilePreviewDock || !mobilePreviewToggle) return;
        mobilePreviewDock.classList.toggle('is-expanded', expanded);
        mobilePreviewToggle.setAttribute('aria-expanded', String(expanded));
        const label = expanded ? mobilePreviewDock.dataset.collapseLabel : mobilePreviewDock.dataset.expandLabel;
        mobilePreviewToggle.setAttribute('aria-label', label);
        mobilePreviewToggle.setAttribute('title', label);
        mobilePreviewToggle.querySelector('[data-mobile-preview-expand-icon]')?.toggleAttribute('hidden', expanded);
        mobilePreviewToggle.querySelector('[data-mobile-preview-collapse-icon]')?.toggleAttribute('hidden', !expanded);
      };
      mobilePreviewToggle?.addEventListener('click', () => {
        setMobilePreviewExpanded(!mobilePreviewDock.classList.contains('is-expanded'));
      });
      form.addEventListener('focusin', (event) => {
        if (event.target.matches('input, textarea, select') && mobilePreviewDock?.classList.contains('is-expanded')) {
          setMobilePreviewExpanded(false);
        }
      });

      const syncLiveArtwork = () => {
        syncPreviewLayout();
        if (!liveArtwork) {
          syncPortablePreview();
          return;
        }
        const usePhoto = usesSuncatcherPhoto();
        const artworkKey = selectedArtworkVisualKey();
        const artworkOption = selectedVisualOption(artworkKey);
        const artworkUrl = artworkOption?.dataset.optionImage || '';
        const previewArtworkState = usePhoto
          ? (photoObjectUrl ? 'photo' : 'fallback')
          : (artworkUrl ? 'artwork' : 'fallback');

        liveArtwork.hidden = usePhoto || !artworkUrl;
        if (artworkUrl) liveArtwork.src = artworkUrl;
        else liveArtwork.src = liveArtwork.dataset.placeholderSrc;
        if (livePhoto) livePhoto.hidden = !usePhoto || !photoObjectUrl;
        if (liveSymbol) liveSymbol.hidden = usePhoto ? Boolean(photoObjectUrl) : Boolean(artworkUrl);
        if (livePiece) livePiece.dataset.previewArtworkState = previewArtworkState;
        syncPortablePreview();
      };

      const syncVisualSelect = (key) => {
        const select = form.querySelector(`[data-visual-select="${key}"]`);
        if (!select) return;
        const option = select.selectedOptions?.[0];
        const value = option?.value || '';
        const imageUrl = option?.dataset.optionImage || '';
        root.querySelectorAll(`[data-visual-option="${key}"]`).forEach((button) => {
          const normalizedOption = normalizeVisualValueForInteraction(button.dataset.optionValue);
          const normalizedValue = normalizeVisualValueForInteraction(value);
          button.setAttribute('aria-pressed', String(Boolean(value) && normalizedOption === normalizedValue));
        });

        const selectedLabel = root.querySelector(`[data-selected-option-label="${key}"]`);
        const selectedImage = root.querySelector(`[data-selected-option-image="${key}"]`);
        const selectedPlaceholder = root.querySelector(`[data-selected-option-placeholder="${key}"]`);
        if (selectedLabel) selectedLabel.textContent = option?.textContent?.trim() || select.options[0]?.textContent?.trim() || '';
        if (selectedImage) {
          if (imageUrl) selectedImage.src = imageUrl;
          else selectedImage.src = selectedImage.dataset.placeholderSrc;
          selectedImage.hidden = !imageUrl;
        }
        selectedPlaceholder?.toggleAttribute('hidden', Boolean(imageUrl));

        if (key === 'background' && liveMoon) {
          if (imageUrl) liveMoon.src = imageUrl;
          else liveMoon.src = liveMoon.dataset.placeholderSrc;
          liveMoon.hidden = !imageUrl;
        }
        syncLiveArtwork();
      };
      const normalizeVisualValueForInteraction = (value) => String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLocaleLowerCase();

      const dedupeGridByValue = (grid) => {
        const seen = new Set();
        grid?.querySelectorAll('[data-visual-option]').forEach((button) => {
          const optionValue = normalizeVisualValueForInteraction(button.dataset.optionValue);
          if (!optionValue) return;
          if (seen.has(optionValue)) button.remove();
          else seen.add(optionValue);
        });
      };
      ['dog-breed', 'cat-pattern', 'pet-artwork', 'background'].forEach((kind) => {
        root.querySelectorAll(`[data-visual-options="${kind}"]`).forEach((grid) => dedupeGridByValue(grid));
      });

      form.addEventListener('click', (event) => {
        const button = event.target.closest('[data-visual-option]');
        if (!button || !form.contains(button)) return;
        const key = button.dataset.visualOption;
        const select = form.querySelector(`[data-visual-select="${key}"]`);
        if (!select || select.disabled) return;
        const selectedValue = button.dataset.optionValue || '';
        const optionNodes = Array.from(select.options || []);
        const exactMatch = optionNodes.find((option) => option.value === selectedValue);
        const normalizedMatch = optionNodes.find(
          (option) => normalizeVisualValueForInteraction(option.value) === normalizeVisualValueForInteraction(selectedValue)
        );
        select.value = (exactMatch || normalizedMatch)?.value || '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });

      form.querySelectorAll('[data-visual-search]').forEach((search) => {
        search.addEventListener('input', () => {
          const key = search.dataset.visualSearch;
          const library = search.closest('[data-visual-library]');
          const query = search.value.trim().toLocaleLowerCase();
          let visibleCount = 0;
          library?.querySelectorAll(`[data-visual-option="${key}"]`).forEach((button) => {
            const searchText = `${button.dataset.optionValue || ''} ${button.textContent || ''}`.toLocaleLowerCase();
            const visible = !query || searchText.includes(query);
            button.hidden = !visible;
            if (visible) visibleCount += 1;
          });
          const empty = library?.querySelector(`[data-visual-empty="${key}"]`);
          empty?.toggleAttribute('hidden', visibleCount > 0);
        });
      });

      form.querySelectorAll('[data-visual-select]').forEach((select) => {
        const key = select.dataset.visualSelect;
        select.addEventListener('change', () => syncVisualSelect(key));
        syncVisualSelect(key);
      });

      const syncPetType = () => {
        const petTypeControl = selectedPetTypeControl();
        const selectedType = petTypeControl?.value || 'Dog';
        const petTypeKey = selectedPetTypeKey();
        const artworkKind = selectedArtworkKind();
        const usesGenericArtwork = artworkKind !== 'dog' && artworkKind !== 'cat';
        const configuredArtworkLabel = petTypeControl?.dataset.artworkLabel || root.dataset.petArtworkLabel || 'Pet artwork';
        const dogField = form.querySelector('[data-dog-breed-field]');
        const dogInput = dogField?.querySelector('select');
        const dogReview = form.querySelector('[data-dog-breed-review]');
        const catField = form.querySelector('[data-cat-pattern-field]');
        const catInput = catField?.querySelector('select');
        const catReview = form.querySelector('[data-cat-pattern-review]');
        const genericField = form.querySelector('[data-generic-pet-artwork-field]');
        const genericInput = genericField?.querySelector('select');
        const genericReview = form.querySelector('[data-generic-pet-artwork-review]');
        const allowsLibraryArtwork = petTypeControl?.dataset.artworkMode !== 'photo';
        const usesLibraryArtwork = !usesSuncatcherPhoto() && allowsLibraryArtwork;

        if (usesGenericArtwork) {
          populateGenericArtwork(artworkKind);
          if (genericField) genericField.dataset.artworkKind = artworkKind;
          root.querySelectorAll('[data-generic-pet-artwork-label]').forEach((label) => {
            label.textContent = configuredArtworkLabel;
          });
          if (genericInput) genericInput.setAttribute('aria-label', configuredArtworkLabel);
        }

        if (dogField && dogInput && dogReview) {
          const dogActive = usesLibraryArtwork && artworkKind === 'dog';
          dogField.hidden = !dogActive;
          dogInput.disabled = !dogActive;
          dogInput.required = dogActive;
          dogReview.hidden = !dogActive;
          updateReview('dog-breed', dogActive ? dogInput.value : '');
        }
        if (catField && catInput && catReview) {
          const catActive = usesLibraryArtwork && artworkKind === 'cat';
          catField.hidden = !catActive;
          catInput.disabled = !catActive;
          catInput.required = catActive;
          catReview.hidden = !catActive;
          updateReview('cat-pattern', catActive ? catInput.value : '');
        }
        if (genericField && genericInput && genericReview) {
          const genericActive = usesLibraryArtwork && usesGenericArtwork;
          genericField.hidden = !genericActive;
          genericInput.disabled = !genericActive;
          genericInput.required = genericActive;
          genericReview.hidden = !genericActive;
          updateReview('pet-artwork', genericActive ? genericInput.value : '');
          if (genericActive) syncVisualSelect('pet-artwork');
        }
        updateReview('pet-type', selectedType);
        if (previewArtworkKind) previewArtworkKind.value = artworkKind;
        syncMediaGroup(petTypeKey);
        syncLiveArtwork();
        syncMoonMessage();
        scheduleStickyUpdate();
      };
      form.querySelectorAll('[data-pet-type]').forEach((input) => input.addEventListener('change', syncPetType));
      syncPetType();
      syncMoonMessage();
      form.querySelector('[data-moon-message-field] input')?.addEventListener('input', syncMoonMessage);

      const artwork = form.querySelector('[data-artwork-source]');
      const photoField = form.querySelector('[data-photo-field]');
      const photoUpload = form.querySelector('[data-photo-upload]');
      const photoError = form.querySelector('[data-photo-error]');
      const photoFileName = form.querySelector('[data-photo-file-name]');
      const photoCrop = form.querySelector('select[data-photo-crop]');
      const photoControls = Array.from(form.querySelectorAll('[data-photo-control]'));
      const suncatcherPhotoFields = form.querySelector('[data-suncatcher-photo-fields]');
      const photoRights = form.querySelector('[data-photo-rights]');
      const suncatcherArtworkModes = Array.from(form.querySelectorAll('[data-suncatcher-artwork-mode]'));

      const syncPhotoControls = () => {
        const values = Object.fromEntries(photoControls.map((control) => [control.dataset.photoControl, Number(control.value)]));
        const zoom = Math.max(1, (values.zoom || 100) / 100);
        const horizontalPosition = values.x ?? 50;
        const verticalPosition = values.y ?? 50;
        const zoomPanRange = zoom - 1;
        photoControls.forEach((control) => {
          const output = form.querySelector(`[data-photo-control-output="${control.dataset.photoControl}"]`);
          if (output) output.textContent = `${control.value}%`;
        });
        root.style.setProperty('--b2h-v3-photo-zoom', String(zoom));
        root.style.setProperty('--b2h-v3-photo-x', `${horizontalPosition}%`);
        root.style.setProperty('--b2h-v3-photo-y', `${verticalPosition}%`);
        root.style.setProperty('--b2h-v3-photo-pan-x', `${(50 - horizontalPosition) * zoomPanRange}%`);
        root.style.setProperty('--b2h-v3-photo-pan-y', `${(50 - verticalPosition) * zoomPanRange}%`);
        if (livePhoto) livePhoto.style.objectFit = photoCrop?.value === 'Full pet' ? 'contain' : 'cover';
        if (photoCrop) {
          const cropLabel = photoCrop.selectedOptions[0]?.textContent?.trim() || photoCrop.value;
          const zoomLabel = photoControls.find((control) => control.dataset.photoControl === 'zoom')?.getAttribute('aria-label') || '';
          updateReview('photo-crop', `${cropLabel}; ${zoomLabel} ${values.zoom || 100}%; X ${horizontalPosition}%; Y ${verticalPosition}%`);
        }
        syncPortablePreview();
      };

      const syncSuncatcherArtworkMode = () => {
        if (!suncatcherArtworkModes.length || !suncatcherPhotoFields) return;
        const usePhoto = usesSuncatcherPhoto();
        suncatcherPhotoFields.hidden = !usePhoto;
        suncatcherPhotoFields.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !usePhoto;
        });
        if (photoUpload) photoUpload.required = usePhoto;
        if (photoRights) photoRights.required = usePhoto;
        form.querySelector('[data-photo-file-review]')?.toggleAttribute('hidden', !usePhoto);
        form.querySelector('[data-photo-crop-review]')?.toggleAttribute('hidden', !usePhoto);
        form.querySelector('[data-photo-note-review]')?.toggleAttribute('hidden', !usePhoto);
        if (!usePhoto) {
          photoValidationToken += 1;
          if (pendingPhotoUrl) URL.revokeObjectURL(pendingPhotoUrl);
          pendingPhotoUrl = null;
          updateReview('photo-file', '');
          updateReview('photo-note', '');
        } else if (photoUpload?.files?.length) {
          syncPhotoUpload();
        }
        syncPetType();
        syncPhotoControls();
        syncLiveArtwork();
        scheduleStickyUpdate();
      };
      suncatcherArtworkModes.forEach((input) => input.addEventListener('change', syncSuncatcherArtworkMode));

      const syncArtwork = () => {
        if (!artwork || !photoField || !photoUpload) return;
        const usesPhoto = artwork.value === 'Pet photo';
        photoField.hidden = !usesPhoto;
        photoUpload.disabled = !usesPhoto;
        photoUpload.required = usesPhoto && root.dataset.photoRequired === 'true';
        if (!usesPhoto) {
          photoValidationToken += 1;
          if (pendingPhotoUrl) URL.revokeObjectURL(pendingPhotoUrl);
          pendingPhotoUrl = null;
          photoUpload.value = '';
          root.dataset.photoState = 'empty';
          photoUpload.setCustomValidity('');
          photoUpload.removeAttribute('aria-invalid');
          if (photoFileName) photoFileName.textContent = root.dataset.photoEmptyMessage || '';
          updateReview('photo-file', '');
          if (photoObjectUrl) URL.revokeObjectURL(photoObjectUrl);
          photoObjectUrl = null;
          if (livePhoto) {
            livePhoto.src = livePhoto.dataset.placeholderSrc;
            livePhoto.hidden = true;
          }
        }
        if (liveSymbol) liveSymbol.hidden = Boolean(photoObjectUrl) || artwork.value === 'Typography only';
        syncPortablePreview();
      };
      artwork?.addEventListener('change', syncArtwork);
      syncArtwork();

      const photoSignatureType = (bytes) => {
        if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return 'image/jpeg';
        if ([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a].every((byte, index) => bytes[index] === byte)) return 'image/png';
        if (String.fromCharCode(...bytes.slice(0, 4)) === 'RIFF' && String.fromCharCode(...bytes.slice(8, 12)) === 'WEBP') return 'image/webp';
        if (['GIF87a', 'GIF89a'].includes(String.fromCharCode(...bytes.slice(0, 6)))) return 'image/gif';
        return '';
      };
      const readPhotoHeader = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => reader.result instanceof ArrayBuffer
          ? resolve(new Uint8Array(reader.result))
          : reject(new Error('Image header could not be read'));
        reader.onerror = () => reject(reader.error || new Error('Image header could not be read'));
        reader.readAsArrayBuffer(file.slice(0, 12));
      });
      const syncPhotoUpload = () => {
        if (!photoUpload) return;
        const validationToken = ++photoValidationToken;
        const file = photoUpload.files?.[0];
        const maxBytes = Number(root.dataset.photoMaxBytes || 0);
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
        const sizeInvalid = Boolean(file && maxBytes > 0 && file.size > maxBytes);
        const typeInvalid = Boolean(file?.type && !allowedTypes.includes(file.type));
        const errorMessage = sizeInvalid
          ? root.dataset.photoSizeError || 'Choose a smaller image.'
          : typeInvalid
            ? root.dataset.photoTypeError || 'Choose a JPG, PNG, or WebP image.'
            : '';
        if (pendingPhotoUrl) URL.revokeObjectURL(pendingPhotoUrl);
        pendingPhotoUrl = null;
        if (photoObjectUrl) URL.revokeObjectURL(photoObjectUrl);
        photoObjectUrl = null;
        photoUpload.setCustomValidity(errorMessage || (file ? root.dataset.photoCheckingMessage || 'Checking image...' : ''));
        root.dataset.photoState = errorMessage ? 'error' : file ? 'checking' : 'empty';
        if (errorMessage) photoUpload.setAttribute('aria-invalid', 'true');
        else photoUpload.removeAttribute('aria-invalid');
        if (photoError) {
          photoError.textContent = errorMessage;
          photoError.hidden = !errorMessage;
        }
        if (photoFileName) {
          const emptyMessage = root.dataset.photoEmptyMessage || '';
          const checkingMessage = root.dataset.photoCheckingMessage || 'Checking image...';
          photoFileName.textContent = file ? `${errorMessage ? '' : checkingMessage + ' '}${file.name}`.trim() : emptyMessage;
        }
        updateReview('photo-file', '');
        if (livePhoto) {
          livePhoto.src = livePhoto.dataset.placeholderSrc;
          livePhoto.hidden = true;
        }
        syncLiveArtwork();
        if (!liveArtwork && liveSymbol) liveSymbol.hidden = Boolean(photoObjectUrl) || artwork?.value === 'Typography only';
        if (!file || errorMessage) return;

        const candidateUrl = URL.createObjectURL(file);
        pendingPhotoUrl = candidateUrl;
        const probe = new Image();
        const finish = (readable, failureMessage = '') => {
          if (validationToken !== photoValidationToken || photoUpload.files?.[0] !== file || photoUpload.disabled || !root.isConnected) {
            URL.revokeObjectURL(candidateUrl);
            if (pendingPhotoUrl === candidateUrl) pendingPhotoUrl = null;
            return;
          }
          pendingPhotoUrl = null;
          if (!readable || probe.naturalWidth < 1 || probe.naturalHeight < 1) {
            URL.revokeObjectURL(candidateUrl);
            const decodeError = failureMessage || root.dataset.photoDecodeError || 'This image could not be opened. Choose another JPG, PNG, or WebP.';
            photoUpload.setCustomValidity(decodeError);
            photoUpload.setAttribute('aria-invalid', 'true');
            root.dataset.photoState = 'error';
            if (photoError) {
              photoError.textContent = decodeError;
              photoError.hidden = false;
            }
            if (photoFileName) photoFileName.textContent = file.name;
            updateReview('photo-file', '');
          } else {
            photoObjectUrl = candidateUrl;
            photoUpload.setCustomValidity('');
            photoUpload.removeAttribute('aria-invalid');
            root.dataset.photoState = 'ready';
            if (photoFileName) photoFileName.textContent = `${root.dataset.photoReadyMessage || ''} ${file.name}`.trim();
            if (livePhoto) livePhoto.src = candidateUrl;
            updateReview('photo-file', file.name);
            openPreviewForMeaningfulInput(photoUpload);
          }
          syncLiveArtwork();
          form.dispatchEvent(new Event('change', { bubbles: true }));
        };
        probe.onload = () => finish(true);
        probe.onerror = () => finish(false);
        void (async () => {
          try {
            const bytes = await readPhotoHeader(file);
            const signatureType = photoSignatureType(bytes);
            if (!signatureType) {
              finish(false);
              return;
            }
            if (!allowedTypes.includes(signatureType) || (file.type && signatureType !== file.type)) {
              finish(false, root.dataset.photoTypeError || 'Choose a JPG, PNG, or WebP image.');
              return;
            }
            if (validationToken !== photoValidationToken || photoUpload.files?.[0] !== file || photoUpload.disabled || !root.isConnected) {
              finish(false);
              return;
            }
            probe.src = candidateUrl;
          } catch (_) {
            finish(false);
          }
        })();
      };
      photoUpload?.addEventListener('change', syncPhotoUpload);
      photoControls.forEach((control) => control.addEventListener('input', syncPhotoControls));
      photoCrop?.addEventListener('change', syncPhotoControls);
      syncSuncatcherArtworkMode();
      syncPhotoControls();
      if (photoUpload?.files?.length) syncPhotoUpload();
      else if (photoUpload) {
        root.dataset.photoState = 'empty';
        if (photoFileName) photoFileName.textContent = root.dataset.photoEmptyMessage || '';
      }
      syncLiveText();
      syncPortablePreview();

      const workflow = form.querySelector('[data-photo-workflow]');
      if (workflow && root.dataset.photoPortraitOnly === 'true') {
        const links = [...workflow.querySelectorAll('[data-workflow-link]')];
        const stages = links.map(link => form.querySelector(`#${CSS.escape(link.hash.slice(1))}`));
        const status = workflow.querySelector('[data-workflow-status]');
        const setWorkflowStage = stage => {
          root.dataset.workflowStage = stage;
          links.forEach((link, index) => {
            const active = link.dataset.workflowLink === stage;
            if (active) link.setAttribute('aria-current', 'step');
            else link.removeAttribute('aria-current');
            stages[index]?.toggleAttribute('data-workflow-active', active);
          });
        };
        const syncPhotoWorkflow = () => {
          const hasPhoto = root.dataset.photoState === 'ready';
          const hasName = Boolean(petNameField?.value.trim());
          const state = root.dataset.photoState === 'error' ? 'error' : hasPhoto ? (hasName ? 'review' : 'photo') : 'empty';
          // Presence feedback only: never equate a file or image-use permission
          // with artwork approval, production readiness or a submitted order.
          workflow.dataset.workflowState = state;
          links[0]?.toggleAttribute('data-workflow-filled', hasPhoto);
          links[1]?.toggleAttribute('data-workflow-filled', hasPhoto && hasName);
          if (status && status.textContent !== workflow.dataset[state]) status.textContent = workflow.dataset[state];
        };
        form.addEventListener('focusin', event => {
          const index = stages.findIndex(stage => stage?.contains(event.target));
          if (index >= 0) setWorkflowStage(links[index].dataset.workflowLink);
        });
        workflow.addEventListener('click', event => {
          const link = event.target.closest('[data-workflow-link]');
          if (links.includes(link)) setWorkflowStage(link.dataset.workflowLink);
          // Leave native anchor navigation, focus and scrolling intact.
        });
        form.addEventListener('input', syncPhotoWorkflow);
        form.addEventListener('change', syncPhotoWorkflow);
        form.addEventListener('reset', () => requestAnimationFrame(syncPhotoWorkflow));
        setWorkflowStage('upload');
        syncPhotoWorkflow();
      }

      const giftToggle = form.querySelector('[data-gift-toggle]');
      const giftField = form.querySelector('[data-gift-note-field]');
      const giftNote = giftField?.querySelector('textarea');
      const syncGift = () => {
        if (!giftToggle || !giftField || !giftNote) return;
        giftField.hidden = !giftToggle.checked;
        giftNote.disabled = !giftToggle.checked;
        if (!giftToggle.checked) {
          giftNote.value = '';
          updateReview('gift-note', '');
        }
        openPreviewForMeaningfulInput(giftToggle);
      };
      giftToggle?.addEventListener('change', syncGift);
      syncGift();

      form.addEventListener('submit', () => {
        if (!form.checkValidity() || !submit) return;
        submit.setAttribute('aria-busy', 'true');
      });

      delete root.dataset.initializing;
      root.dataset.initialized = 'true';
      root.dispatchEvent(new CustomEvent('b2h:studio-ready'));
    };

    const initAll = (scope = document) => customElements.whenDefined('media-gallery').then(() => {
      scope.querySelectorAll('[data-b2h-product-studio]').forEach(root => {
        if (root.isConnected) initStudio(root);
      });
    });
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
